import isNil from 'lodash-es/isNil';

export function trim(value: string): string {
    return value ? ('' + value).trim() : null;
}

export function sanitizeToAlphanumeric(value: string): string {
    return value.replaceAll(/[^a-zA-Z\d]/g, '')
}

export function formatPhone(value: string): string{
        const l = value?.length;
        const firstCar = value?.charAt(0) ;
        if(l === 10 && firstCar !== '+'){
            // 00 00 00 00 00
            return `${value.slice(0,2)} ${value.slice(2,4)} ${value.slice(4,6)} ${value.slice(6,8)} ${value.slice(8,10)}`
        }
        else if(l === 12 && firstCar === '+') {
            // +00 0 00 00 00 00
            return `${value.slice(0,3)} ${value.charAt(3)} ${value.slice(4,6)} ${value.slice(6,8)} ${value.slice(8,10)} ${value.slice(10,12)}`
        }
    return value;
}

export function removePhoneCarSeparator(value: string): string{
    return (value !== null && value !== undefined) ? value.replace(/[- \.]/g,'') : null;
}

export function removeSpaces(value: string): string {
    return (value !== null && value !== undefined) ? ('' + value).replace(/ /g, '') : null;
}

export function capitalize(word: string): string {
    return (!isNil(word)) ? word.charAt(0).toLocaleUpperCase().trim() + word.slice(1).trim() : '';
}

export function recursiveString(start, end, stringToInject, pass): string {
    if (pass-- > 0) {
        return start + stringToInject + recursiveString(start, end, stringToInject, pass) + end;
    } else {
        return start + stringToInject + end;
    }
}

export function isNullOrEmpty(value: any): boolean {
    return value !== 0 && !trim(value);
}

/**
 * Remplace les <br> et </p> par des sauts de ligne \r\n
 * Supprime les tags html et remplace les caractères html (&eacute > é ...)
 * voir si il faut rajouter d'autres caractères
 */
export function htmlToText(value: string): string {
    const replacement = {
        '<\\/p>|<br \\/>|<br>': '\r\n',
        '<[^>]*>': '',
        '&eacute;': 'é',
        '&egrave;': 'è',
        '&amp;': '&',
        '&agrave;': 'à',
        '&ecirc;': 'ê',
        '&acirc;': 'à',
        '&ccedil;': 'ç',
        '&ugrave;': 'ù',
        '&icirc;': 'î',
        '&ucirc;': 'û',
        '&ocirc;': 'ô',
        '&nbsp;': ' ',
        '&euro;': '€',
        '&rsquo;': '\'',
        '&quot;': '"',
        '&laquo;': '«',
        '&raquo;': '»',
        '&lsaquo;': '‹',
        '&rsaquo;': '›',
        '&lsquo;': '‘'

    };
    for (const regexp of Object.keys(replacement)) {
        value = value.replace(new RegExp(regexp, 'g'), replacement[regexp]);
    }
    return value;
}

export function removeEspace(value: string): string {
    return (value || '').replace(/[ \t\v]/gi, '');
}
